<template>
  <v-sheet theme="dark">
    <v-img
      :src="photoFront"
      aspect-ratio="1.778"
      content-class="d-flex align-center"
      cover
      gradient="to top, rgba(38, 50, 56, 0.7), rgba(38, 50, 56, 0.7)"
      max-height="720"
    >
      <v-container>
        <v-row>
          <v-col>
            <h1 class="text-h2 text-md-h1 text-center">
              <span class="text-uppercase font-weight-bold">West Wind</span>
              <span class="font-weight-bold"> Automotive</span>
            </h1>
            <h4 class="text-h5 text-md-h4 text-center font-weight-medium my-2">
              Quality automotive repair / Locally owned for 47 years
            </h4>
            <h5 class="text-h5 text-center font-weight-normal">
              351 Valencia Street, San Francisco
            </h5>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-row>
              <v-col class="d-flex flex-row flex-wrap justify-center ga-2">
                <v-btn
                  :href="`tel:${contactPhone}`"
                  color="primary"
                  size="large"
                  >{{ contactPhone }}</v-btn
                >

                <v-btn
                  :href="`mailto:${infoEmail}?subject=Questions`"
                  color="primary"
                  size="large"
                  >Email Us</v-btn
                >

                <v-dialog max-width="700px" scrollable>
                  <template #activator="{ props: activatorProps }">
                    <v-btn v-bind="activatorProps" color="primary" size="large"
                      >Get An Estimate</v-btn
                    ></template
                  >

                  <template #default="{ isActive }">
                    <RepairService dialog>
                      <template #actions>
                        <v-btn @click="isActive.value = false">Close</v-btn>
                        <v-spacer />
                      </template>
                    </RepairService>
                  </template>
                </v-dialog>
              </v-col>
            </v-row>

            <v-row justify="center">
              <v-col cols="auto">
                <v-card rounded="pill" variant="flat">
                  <v-card-text
                    class="d-flex flex-row flex-wrap align-center justify-center ga-2"
                    ><span class="font-weight-bold"
                      >Check out our 5-star reviews!</span
                    >
                    <v-chip
                      :href="googleReviewsUrl"
                      color="red-darken-4"
                      small
                      target="_blank"
                      variant="flat"
                      >Google Reviews</v-chip
                    >
                    <v-chip
                      :href="yelpReviewsUrl"
                      color="red-darken-4"
                      small
                      target="_blank"
                      variant="flat"
                      >Yelp</v-chip
                    >
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row justify="center">
          <v-col cols="auto">
            <v-card
              :style="{ border: `1px solid ${colors.red.darken4}` }"
              class="pa-2"
              tile
              variant="flat"
            >
              <template #title>
                <span class="text-uppercase font-weight-black text-red"
                  >Specials</span
                >
                <span class="text-wrap">
                  on Detailing & Ceramic Coating.
                  <a :href="`tel:${contactPhone}`" class="text-white"
                    >Call us</a
                  >
                  for more info.</span
                >
              </template>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-img>
  </v-sheet>
</template>

<script setup lang="ts">
import colors from 'vuetify/util/colors'
import photoFront from '#root/assets/images/photo-front.jpg'

const contactPhone = import.meta.env.VITE_PHONE
const infoEmail = import.meta.env.VITE_EMAIL
const googleReviewsUrl = import.meta.env.VITE_GOOGLE_REVIEWS_URL
const yelpReviewsUrl = import.meta.env.VITE_YELP_REVIEWS_URL
</script>
